import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { EpoxyAreas } from "@/components/EpoxyAreas";
import { Services } from "@/components/Services";
import { CTABand } from "@/components/CTABand";
import { WhyUs } from "@/components/WhyUs";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Seo } from "@/components/Seo";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => scrollToId(target), 350);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div className="bg-ink text-white">
      <Seo
        title="Epoxidharzböden Gronau (Westf.) | Terbeck Service GbR"
        description="Epoxidharzböden & Bodenbeschichtungen, Hausmeisterservice, Gebäude- und Pflasterreinigung in Gronau (Westf.) & Kreis Borken. Angebot: 0151 50778186"
        path="/"
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <EpoxyAreas />
        <Services />
        <CTABand />
        <WhyUs />
        <About />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
